import { isOnline } from "@/lib/onlineStatus";
import { StatusPill } from "./StatusPill";

export function OnlineStatusBadge({
  lastSeenAt,
}: {
  lastSeenAt: string | null;
}) {
  if (!lastSeenAt) {
    return <StatusPill variant="idle">Never connected</StatusPill>;
  }

  return isOnline(lastSeenAt) ? (
    <StatusPill variant="online">Online</StatusPill>
  ) : (
    <StatusPill variant="offline">Offline</StatusPill>
  );
}
